import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Radio,
  Typography,
} from "@mui/material";
import MainCalculatorsList from "../MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import { CalculatorsType } from "../ConstantsEN";
import SharedHelmet from "../Helmet";
const TITLE = "Muslim Name Generator - Find Arabic & Islamic Names with Meanings";
const DESCRIPTION = "Discover unique and meaningful names with our Muslim Name Generator. Find Arabic and Islamic names for boys and girls, including names with their meanings. Whether you need traditional or modern names, our tool offers a diverse selection to help you choose the perfect name for your baby.";
const KEYWORDS = "Muslim Name Generator, Arabic Name Generator, Islamic Name Generator, Baby Name Generator Muslim, Muslim Names with Meanings, Islamic Baby Names, Arabic Names Generator, Muslim Baby Names, Islamic Names with Meanings";
const OG_URL = 'https://do-calculate.com/calculator/en/random-name-generator/';
const arabicIslamicNames = [
  { name: "Mohammed", meaning: "The praised and beloved, the name of the Prophet of the Ummah, peace be upon him", gender: "male", type: "islamic" },
  { name: "Ahmed", meaning: "The praised one, another name of the Prophet Muhammad, peace be upon him", gender: "male", type: "islamic" },
  { name: "Baraa", meaning: "Innocent of charges", gender: "male", type: "islamic" },
  { name: "Ali", meaning: "High, a name of honor and elevation", gender: "male", type: "islamic" },
  { name: "Yousef", meaning: "One who increases in beauty and goodness", gender: "male", type: "islamic" },
  { name: "Omar", meaning: "Life and long life", gender: "male", type: "islamic" },
  { name: "Tariq", meaning: "The shining star, a name for someone who paves the way for others", gender: "male", type: "islamic" },
  { name: "Ridwan", meaning: "Satisfaction and joy", gender: "male", type: "islamic" },
  { name: "Khaled", meaning: "Eternal, one who remains and does not vanish", gender: "male", type: "islamic" },
  { name: "Ziyad", meaning: "Increase and growth in goodness", gender: "male", type: "islamic" },
  { name: "Abdullah", meaning: "Servant of Allah", gender: "male", type: "islamic" },
  { name: "Saeed", meaning: "Happy and joyful", gender: "male", type: "islamic" },
  { name: "Hassan", meaning: "Beauty and goodness", gender: "male", type: "islamic" },
  { name: "Mustafa", meaning: "The chosen one", gender: "male", type: "islamic" },
  { name: "Abdul Rahman", meaning: "Servant of the Most Merciful, one with great mercy", gender: "male", type: "islamic" },
  { name: "Abdul Aziz", meaning: "Servant of the Mighty, one with strength and dignity", gender: "male", type: "islamic" },
  { name: "Faruq", meaning: "Distinguisher between right and wrong", gender: "male", type: "islamic" },
  { name: "Nur Ad-Din", meaning: "Light of the religion", gender: "male", type: "islamic" },
  { name: "Usama", meaning: "The brave lion, a name symbolizing courage and strength", gender: "male", type: "islamic" },
  { name: "Ayman", meaning: "The forbearing and merciful", gender: "male", type: "islamic" },
  { name: "Fahd", meaning: "Leopard, a name representing courage and strength", gender: "male", type: "islamic" },
  { name: "Salman", meaning: "Peace and safety", gender: "male", type: "islamic" },
  { name: "Mumin", meaning: "The believer, one who believes in Allah", gender: "male", type: "islamic" },
  { name: "Riyadh", meaning: "Garden and comfort", gender: "male", type: "islamic" },
  { name: "Saleh", meaning: "The righteous and beneficial", gender: "male", type: "islamic" },
  { name: "Yaser", meaning: "One who makes things easy and facilitates matters", gender: "male", type: "islamic" },
  { name: "Mu'adh", meaning: "The protector and defender", gender: "male", type: "islamic" },
  { name: "Amjad", meaning: "Glory and pride", gender: "male", type: "islamic" },
  { name: "Anas", meaning: "Companion and friend", gender: "male", type: "islamic" },
  { name: "Jalal", meaning: "Glory and greatness", gender: "male", type: "islamic" },
  { name: "Muhsin", meaning: "The one who does good and is treated with goodness", gender: "male", type: "islamic" },
  { name: "Adel", meaning: "The just and fair", gender: "male", type: "islamic" },
  { name: "Nasser", meaning: "The victorious and triumphant", gender: "male", type: "islamic" },
  { name: "Mujahid", meaning: "Striving in the path of Allah", gender: "male", type: "islamic" },
  { name: "Hamza", meaning: "The brave lion, a name symbolizing courage and strength", gender: "male", type: "islamic" },
  { name: "Ilyas", meaning: "Referring to the Prophet Elias (Elijah), and the name means 'My God is Yahweh'", gender: "male", type: "islamic" },
  { name: "Ayyub", meaning: "Referring to the Prophet Job (Ayub), and the name means 'Patient in the face of adversity'", gender: "male", type: "islamic" },
  { name: "Idris", meaning: "Referring to the Prophet Enoch (Idris), and the name means 'Studious'", gender: "male", type: "islamic" },
  { name: "As-hab", meaning: "A name given to lions in the Quran", gender: "male", type: "islamic" },
  { name: "Asil", meaning: "Referring to the roots, but in the Quran, it refers to the sunset", gender: "male", type: "islamic" },
  { name: "Aman", meaning: "A name indicating tranquility and calmness", gender: "male", type: "islamic" },
  { name: "Amin", meaning: "One who possesses the quality of trustworthiness, the one who safeguards trusts in general", gender: "male", type: "islamic" },
  { name: "Rabih", meaning: "The one who is capable of achieving gains and profits", gender: "male", type: "islamic" },
  { name: "Amjad", meaning: "A name indicating the attainment of a distinguished position", gender: "male", type: "islamic" },
  { name: "Anas", meaning: "A name given to those who feel affection and tranquility", gender: "male", type: "islamic" },
  { name: "Ashja", meaning: "Derived from bravery, describing a person who is brave and mighty", gender: "male", type: "islamic" },
  { name: "Asmaei", meaning: "The first meaning is a person with small ears, and the second meaning is a small sword", gender: "male", type: "islamic" },
  { name: "Thabit", meaning: "A name indicating a person's steadfastness in the face of truth", gender: "male", type: "islamic" },
  { name: "Thamud", meaning: "A name given to the generous person who spends his wealth due to his generosity", gender: "male", type: "islamic" },
  { name: "Aisha", meaning: "Derived from the verb 'aasha', meaning 'to live'", gender: "female", type: "islamic" },
  { name: "Fatima", meaning: "Derived from the verb 'fatama', meaning 'to abstain'", gender: "female", type: "islamic" },
  { name: "Umm Kulthum", meaning: "The woman with a full face", gender: "female", type: "islamic" },
  { name: "Aatika", meaning: "Generous and beautiful", gender: "female", type: "islamic" },
  { name: "Afeefah", meaning: "Pure and chaste woman", gender: "female", type: "islamic" },
  { name: "Zainab", meaning: "A beautiful and fragrant tree", gender: "female", type: "islamic" },
  { name: "Sawda", meaning: "The land on which palm trees are planted", gender: "female", type: "islamic" },
  { name: "Rahma", meaning: "Softness and compassion", gender: "female", type: "islamic" },
  { name: "Hanan", meaning: "Sympathy and tenderness", gender: "female", type: "islamic" },
  { name: "Iman", meaning: "Belief in Allah, His angels, His books, His messengers, the Last Day, and destiny, whether good or bad", gender: "female", type: "islamic" },
  { name: "Noor", meaning: "Radiance and guidance", gender: "female", type: "islamic" },
  { name: "Hikmah", meaning: "Wisdom and understanding", gender: "female", type: "islamic" },
  { name: "Zainab", meaning: "Beautiful flower", gender: "female", type: "islamic" },
  { name: "Maryam", meaning: "Virgin Mary", gender: "female", type: "islamic" },
  { name: "Sarah", meaning: "Easy and tranquil", gender: "female", type: "islamic" },
  { name: "Hajar", meaning: "Fleeing woman", gender: "female", type: "islamic" },
  { name: "Aasiya", meaning: "The disobedient, but the name is used in a positive context referring to Asiya, the wife of Pharaoh who believed in Allah", gender: "female", type: "islamic" },
  { name: "Khadija", meaning: "She who engages in activities that cause the mind and heart to grow, referring to the Prophet's first wife Khadijah", gender: "female", type: "islamic" },
  { name: "Raihana", meaning: "Beautiful flower", gender: "female", type: "islamic" },
  { name: "Rayman", meaning: "Small palm tree", gender: "female", type: "islamic" },
  { name: "Hawraa", meaning: "Beautiful woman", gender: "female", type: "islamic" },
  { name: "Jannat", meaning: "Garden, often referring to paradise", gender: "female", type: "islamic" },
  { name: "Hoor", meaning: "Beautiful women in paradise", gender: "female", type: "islamic" },
  { name: "Sundus", meaning: "Soft silk", gender: "female", type: "islamic" },
  { name: "Naeem", meaning: "Happiness and comfort", gender: "female", type: "islamic" },
  { name: "Musk", meaning: "Fragrant perfume", gender: "female", type: "islamic" },
  { name: "Iman", meaning: "A name indicating belief in Allah", gender: "female", type: "islamic" },
  { name: "Mahabba", meaning: "A name indicating love and affection", gender: "female", type: "islamic" },
  { name: "Sa'ada", meaning: "A name indicating happiness and joy", gender: "female", type: "islamic" },
  { name: "Amal", meaning: "A name indicating hope and optimism", gender: "female", type: "islamic" },
  { name: "Farah", meaning: "A name indicating joy and happiness", gender: "female", type: "islamic" },
  { name: "Hayat", meaning: "A name indicating life and existence", gender: "female", type: "islamic" },
  { name: "Ghada", meaning: "A name indicating a beautiful girl", gender: "female", type: "islamic" },
  { name: "Zahra", meaning: "A name indicating a beautiful flower", gender: "female", type: "islamic" },
  { name: "Iman", meaning: "A name indicating belief in Allah", gender: "female", type: "islamic" },
  { name: "Islam", meaning: "A name indicating submission to Allah", gender: "female", type: "islamic" },
  { name: "Taqwa", meaning: "A name indicating fear of Allah and obedience to Him", gender: "female", type: "islamic" },
  { name: "Rahma", meaning: "A name indicating tenderness and compassion", gender: "female", type: "islamic" },
  { name: "Hanan", meaning: "A name indicating sympathy and tenderness", gender: "female", type: "islamic" },
  { name: "Sundus", meaning: "A name indicating the garments of the people of paradise", gender: "female", type: "islamic" },
  { name: "Jannat", meaning: "A name indicating the gardens of paradise with multiple high positions", gender: "female", type: "islamic" },
  { name: "Hoor", meaning: "A name indicating the reward of the believers in paradise", gender: "female", type: "islamic" },
  { name: "Qatuf", meaning: "All that can be picked from the fruits of paradise", gender: "female", type: "islamic" },
  { name: "Firdaus", meaning: "The highest place in paradise", gender: "female", type: "islamic" },
  { name: "Kawthar", meaning: "A name from the rivers of paradise", gender: "female", type: "islamic" },
  { name: "Namarq", meaning: "The cushions on which the people of paradise recline", gender: "female", type: "islamic" },
  { name: "Istibraq", meaning: "The garments of the people of paradise", gender: "female", type: "islamic" },
  { name: "Ihab", meaning: "Preparation of something or a gift and presenting it to someone, indicating generosity.", gender: "male", type: "eastern" },
  { name: "Wajdi", meaning: "Signifying love, joy, and intense affection. An ancient Arabic name.", gender: "male", type: "eastern" },
  { name: "Kayan", meaning: "Denotes high value, existence, and prestigious status. A new Arabic name.", gender: "male", type: "eastern" },
  { name: "Fahd", meaning: "Refers to the cheetah, symbolizing strength and courage in Arab culture.", gender: "male", type: "eastern" },
  { name: "Raed", meaning: "The pioneer or leader, indicating a person who leads and advances.", gender: "male", type: "eastern" },
  { name: "Jad", meaning: "Signifying generosity and kindness. A name for a generous and noble person.", gender: "male", type: "eastern" },
  { name: "Saleh", meaning: "Means righteous or beneficial, indicating goodness and success.", gender: "male", type: "eastern" },
  { name: "Majd", meaning: "Means glory and greatness. A name indicating a person who achieves great accomplishments.", gender: "male", type: "eastern" },
  { name: "Hani", meaning: "Means happy and joyful, indicating happiness and comfort.", gender: "male", type: "eastern" },
  { name: "Nadeem", meaning: "Means loyal and companionable, indicating a person who is an intimate friend.", gender: "male", type: "eastern" },
  { name: "Muath", meaning: "Means the protector and the sheltered, indicating a person who protects others.", gender: "male", type: "eastern" },
  { name: "Adel", meaning: "Means justice and fairness, indicating a person who seeks justice in all matters.", gender: "male", type: "eastern" },
  { name: "Samer", meaning: "Means night and staying awake, indicating a person who enjoys activity at night.", gender: "male", type: "eastern" },
  { name: "Bassel", meaning: "Means brave and bold, representing a person with a strong spirit.", gender: "male", type: "eastern" },
  { name: "Mujtaba", meaning: "Means chosen and preferred, indicating a person who is esteemed and chosen.", gender: "male", type: "eastern" },
  { name: "Riyad", meaning: "Means gardens and meadows, representing beauty and nature.", gender: "male", type: "eastern" },
  { name: "Ammar", meaning: "Means building and development, indicating a person who seeks to improve things around him.", gender: "male", type: "eastern" },
  { name: "Tariq", meaning: "Means successful and achieving, indicating a person who achieves success in his field.", gender: "male", type: "eastern" },
  { name: "Aliyan", meaning: "Means high and luxurious, representing a person of high value.", gender: "male", type: "eastern" },
  { name: "Rayan", meaning: "Means the green branch or the person who drinks until satisfied.", gender: "male", type: "eastern" },
  { name: "Asil", meaning: "Expresses the owner of authenticity and excellence.", gender: "male", type: "eastern" },
  { name: "Dorgham", meaning: "Associated with one of the names of the lion and means strength, courage, and daring.", gender: "male", type: "eastern" },
  { name: "Muhab", meaning: "Expresses a person with dignity, respect, and reverence.", gender: "male", type: "eastern" },
  { name: "Kanan", meaning: "Means the curtain, symbolizing secrecy and protection.", gender: "male", type: "eastern" },
  { name: "Snan", meaning: "Refers to a strong, fast, and lively person.", gender: "male", type: "eastern" },
  { name: "Himam", meaning: "Expresses a brave and courageous person.", gender: "male", type: "eastern" },
  { name: "Nishan", meaning: "A Kurdish-origin name meaning a sign.", gender: "male", type: "eastern" },
  { name: "Ajwad", meaning: "Refers to the best person among people.", gender: "male", type: "eastern" },
  { name: "Abeel", meaning: "The beautiful person.", gender: "male", type: "eastern" },
  { name: "Nawfal", meaning: "The generous giver.", gender: "male", type: "eastern" },
  { name: "Saheer", meaning: "The one who stays up late.", gender: "male", type: "eastern" },
  { name: "Molham", meaning: "Derived from inspiration.", gender: "male", type: "eastern" },
  { name: "Luay", meaning: "The wild bull.", gender: "male", type: "eastern" },
  { name: "Muath", meaning: "The person protected by Allah.", gender: "male", type: "eastern" },
  { name: "Nayrouz", meaning: "Derived from the spring festival.", gender: "male", type: "eastern" },
  { name: "Raif", meaning: "Derived from kindness and mercy.", gender: "male", type: "eastern" },
  { name: "Taaib", meaning: "Derived from repentance and is obedient.", gender: "male", type: "eastern" },
  { name: "Asmar", meaning: "The brown color.", gender: "male", type: "eastern" },
  { name: "Bahee", meaning: "Very beautiful and handsome.", gender: "male", type: "eastern" },
  { name: "Tayam", meaning: "The departure of the mind due to extreme love.", gender: "male", type: "eastern" },
  { name: "Baraa", meaning: "The person free from defects.", gender: "male", type: "eastern" },
  { name: "Bashar", meaning: "The one with a clear face.", gender: "male", type: "eastern" },
  { name: "Dagher", meaning: "The attacker with force.", gender: "male", type: "eastern" },
  { name: "Yaman", meaning: "The blessed and fortunate.", gender: "male", type: "eastern" },
  { name: "Dali", meaning: "The black grape.", gender: "male", type: "eastern" },
  { name: "Dhu al-Faqar", meaning: "A sword name.", gender: "male", type: "eastern" },
  { name: "Thaer", meaning: "Announcing the revolution.", gender: "male", type: "eastern" },
  { name: "Aaser", meaning: "The extremely strong.", gender: "male", type: "eastern" },
  { name: "Mazen", meaning: "Derived from clouds, meaning rainy.", gender: "male", type: "eastern" },
  { name: "Amjad", meaning: "The owner of deep glory.", gender: "male", type: "eastern" },
  { name: "Argud", meaning: "Fertile land.", gender: "male", type: "eastern" },
  { name: "Bilal", meaning: "The water that moistens the throat.", gender: "male", type: "eastern" },
  { name: "Bibars", meaning: "The strong fighter.", gender: "male", type: "eastern" },
  { name: "Bassel", meaning: "The brave.", gender: "male", type: "eastern" },
  { name: "Bahir", meaning: "The successful achiever.", gender: "male", type: "eastern" },
  { name: "Bahe", meaning: "Derived from splendor and beauty.", gender: "male", type: "eastern" },
  { name: "Taim", meaning: "The servant.", gender: "male", type: "eastern" },
  { name: "Thamer", meaning: "The fruitful or productive one.", gender: "male", type: "eastern" },
  { name: "Jaser", meaning: "The bold one.", gender: "male", type: "eastern" },
  { name: "Hatim", meaning: "The judge or ruler.", gender: "male", type: "eastern" },
  { name: "Hamza", meaning: "Derived from strength and toughness.", gender: "male", type: "eastern" },
  { name: "Haleem", meaning: "Derived from the quality of forbearance or patience.", gender: "male", type: "eastern" },
  { name: "Basm", meaning: "Derived from smiling and cheerfulness.", gender: "male", type: "eastern" },
  { name: "Fahd", meaning: "The name of a known predatory animal, symbolizing strength.", gender: "male", type: "eastern" },
  { name: "Ziyad", meaning: "Derived from increase and abundance.", gender: "male", type: "eastern" },
  { name: "Ghassan", meaning: "In the prime of youth.", gender: "male", type: "eastern" },
  { name: "Khatir", meaning: "What comes to mind.", gender: "male", type: "eastern" },
  { name: "Dani", meaning: "The person close in place.", gender: "male", type: "eastern" },
  { name: "Rafil", meaning: "Slightly arrogant and prideful.", gender: "male", type: "eastern" },
  { name: "Zuhair", meaning: "Derived from blooming flowers.", gender: "male", type: "eastern" },
  { name: "Kareem", meaning: "A name given to a generous person.", gender: "male", type: "eastern" },
  { name: "Tamer", meaning: "A name indicating plenty of provisions.", gender: "male", type: "eastern" },
  { name: "Suheil", meaning: "A name of a star in the sky.", gender: "male", type: "eastern" },
  { name: "Yahya", meaning: "A name of a prophet among the prophets of God.", gender: "male", type: "eastern" },
  { name: "Nawfal", meaning: "A name given to a person who gives a lot.", gender: "male", type: "eastern" },
  { name: "Ziyad", meaning: "A name given to a person representing growth and giving.", gender: "male", type: "eastern" },
  { name: "Raji", meaning: "A name given to a person who hopes for something.", gender: "male", type: "eastern" },
  { name: "Saheer", meaning: "A name given to someone who stays up late.", gender: "male", type: "eastern" },
  { name: "Khatib", meaning: "A name given to someone who is a frequent speaker.", gender: "male", type: "eastern" },
  { name: "Ramez", meaning: "A name given to someone who signals or gestures.", gender: "male", type: "eastern" },
  { name: "Shadi", meaning: "A name given to a seeker of knowledge and literature.", gender: "male", type: "eastern" },
  { name: "Mazen", meaning: "A name given to someone distinguished among his people.", gender: "male", type: "eastern" },
  { name: "Bashar", meaning: "A name given to someone who brings good news to others.", gender: "male", type: "eastern" },
  { name: "Baheer", meaning: "A name given to someone with an illuminating face.", gender: "male", type: "eastern" },
  { name: "Mulhim", meaning: "A name given to someone who guides others to do good.", gender: "male", type: "eastern" },
  { name: "Yazeed", meaning: "A name given to someone representing growth and prosperity.", gender: "male", type: "eastern" },
  { name: "Reenad", meaning: "Intelligent and fragrant scent, also the name of the specific incense for the Kaaba.", gender: "female", type: "eastern" },
  { name: "Mayar", meaning: "Bringer of luck or goodness.", gender: "female", type: "eastern" },
  { name: "Layan", meaning: "Derived from softness and flexibility.", gender: "female", type: "eastern" },
  { name: "Zeina", meaning: "Means decoration and beauty.", gender: "female", type: "eastern" },
  { name: "Fatima", meaning: "An Arabic name associated with a distinguished and bright girl.", gender: "female", type: "eastern" },
  { name: "Ruba", meaning: "Means growth and prosperity.", gender: "female", type: "eastern" },
  { name: "Malak", meaning: "Refers to the heavenly, kind, and beautiful being.", gender: "female", type: "eastern" },
  { name: "Reham", meaning: "Means softness and gentleness.", gender: "female", type: "eastern" },
  { name: "Wi'am", meaning: "Means harmony and balance.", gender: "female", type: "eastern" },
  { name: "Safaa", meaning: "Means purity and serenity.", gender: "female", type: "eastern" },
  { name: "Maysaa", meaning: "Means rainy night.", gender: "female", type: "eastern" },
  { name: "Iman", meaning: "Means faith and uprightness.", gender: "female", type: "eastern" },
  { name: "Samiya", meaning: "Means heavenly and elevated.", gender: "female", type: "eastern" },
  { name: "Nora", meaning: "Means light and radiance.", gender: "female", type: "eastern" },
  { name: "Lama", meaning: "Means a tender and beautiful gaze.", gender: "female", type: "eastern" },
  { name: "Jawaher", meaning: "Means jewels and precious stones.", gender: "female", type: "eastern" },
  { name: "Inas", meaning: "Means comfort and tranquility.", gender: "female", type: "eastern" },
  { name: "Nadia", meaning: "Means rare and unique.", gender: "female", type: "eastern" },
  { name: "Lubna", meaning: "Means pure and chaste white milk.", gender: "female", type: "eastern" },
  { name: "Hala", meaning: "Means the light that surrounds the moon.", gender: "female", type: "eastern" },
  { name: "Sara", meaning: "Means easy and content.", gender: "female", type: "eastern" },
  { name: "Hind", meaning: "Means gift and generosity.", gender: "female", type: "eastern" },
  { name: "Buthol", meaning: "Means pure and virtuous.", gender: "female", type: "eastern" },
  { name: "Raghad", meaning: "Means comfort and enjoyment.", gender: "female", type: "eastern" },
  { name: "Miada", meaning: "Means the happy girl.", gender: "female", type: "eastern" },
  { name: "Ilham", meaning: "Means inspiration and revelation.", gender: "female", type: "eastern" },
  { name: "Rana", meaning: "Means singing and softness.", gender: "female", type: "eastern" },
  { name: "Wassan", meaning: "Means beauty and radiance.", gender: "female", type: "eastern" },
  { name: "Jameela", meaning: "Means beauty and charm.", gender: "female", type: "eastern" },
  { name: "Lateefa", meaning: "Means kindness and gentleness.", gender: "female", type: "eastern" },
  { name: "Haya", meaning: "Means lively and energetic.", gender: "female", type: "eastern" },
  { name: "Reham", meaning: "Means softness and calmness.", gender: "female", type: "eastern" },
  { name: "Faten", meaning: "Means enchanting and attractive.", gender: "female", type: "eastern" },
  { name: "Tulay", meaning: "Light of the gentle moon.", gender: "female", type: "eastern" },
  { name: "Tawana", meaning: "First raindrop from the sky.", gender: "female", type: "eastern" },
  { name: "Arla", meaning: "Foreign name meaning eagle.", gender: "female", type: "eastern" },
  { name: "Bareen", meaning: "Hindi name meaning angel or fairy.", gender: "female", type: "eastern" },
  { name: "Jina", meaning: "The noble girl.", gender: "female", type: "eastern" },
  { name: "Reem", meaning: "The loving or compassionate girl.", gender: "female", type: "eastern" },
  { name: "Ghala", meaning: "Derived from excess, meaning increased value.", gender: "female", type: "eastern" },
  { name: "Hanouf", meaning: "The smiling woman.", gender: "female", type: "eastern" },
  { name: "Yulia", meaning: "Greek name meaning gentle speech.", gender: "female", type: "eastern" },
  { name: "Mila", meaning: "The tree with many branches.", gender: "female", type: "eastern" },
  { name: "Lama", meaning: "Darkness on the lips.", gender: "female", type: "eastern" },
  { name: "Rubin", meaning: "German name meaning maker of glory.", gender: "female", type: "eastern" },
  { name: "Wana", meaning: "Foreign name meaning gift.", gender: "female", type: "eastern" },
  { name: "Layan", meaning: "Derived from softness, meaning gentleness and ease.", gender: "female", type: "eastern" },
  { name: "Laysa", meaning: "The beautiful girl in appearance and character.", gender: "female", type: "eastern" },
  { name: "Meys", meaning: "Swagger and sway.", gender: "female", type: "eastern" },
  { name: "Dima", meaning: "Rain with tranquility.", gender: "female", type: "eastern" },
  { name: "Raheef", meaning: "Gentleness and calmness.", gender: "female", type: "eastern" },
  { name: "Ruba", meaning: "Derived from Rubwa, meaning anything above the ground.", gender: "female", type: "eastern" },
  { name: "Selia", meaning: "Wide green earth.", gender: "female", type: "eastern" },
  { name: "Masa", meaning: "Bright precious stone.", gender: "female", type: "eastern" },
  { name: "Sadeem", meaning: "Soft mist.", gender: "female", type: "eastern" },
  { name: "Asia", meaning: "Beautiful girl's name, also the name of one of the continents in the ancient world.", gender: "female", type: "eastern" },
  { name: "Arjwan", meaning: "Beautiful girl's name, also the name of a distinctive flower.", gender: "female", type: "eastern" },
  { name: "Aseel", meaning: "Beautiful girl's name, also the name of a river in paradise.", gender: "female", type: "eastern" },
  { name: "Afnan", meaning: "Beautiful girl's name, also the name of fruitful trees.", gender: "female", type: "eastern" },
  { name: "Ahlam", meaning: "Beautiful girl's name, also the name of beautiful dreams.", gender: "female", type: "eastern" },
  { name: "Atheer", meaning: "Beautiful girl's name, also the name of the air spread in the universe.", gender: "female", type: "eastern" },
  { name: "Asmaa", meaning: "Beautiful girl's name, also the name of names.", gender: "female", type: "eastern" },
  { name: "Azhaar", meaning: "Beautiful girl's name, also the name of beautiful flowers.", gender: "female", type: "eastern" },
  { name: "Bader", meaning: "Beautiful girl's name, also the name of the full moon.", gender: "female", type: "eastern" },
  { name: "Bayan", meaning: "Beautiful girl's name, also the name of clarity and appearance.", gender: "female", type: "eastern" },
  { name: "Taya", meaning: "Beautiful girl's name, also the name of a river in paradise.", gender: "female", type: "eastern" },
  { name: "Tasneem", meaning: "Beautiful girl's name, also the name of a river in paradise.", gender: "female", type: "eastern" },
  { name: "Tuba", meaning: "Beautiful girl's name, also the name of repentance and turning to God.", gender: "female", type: "eastern" },
  { name: "Juman", meaning: "Beautiful girl's name, also the name of pearls and jewels.", gender: "female", type: "eastern" },
  { name: "Hoor", meaning: "Beautiful girl's name, also the name of the women of paradise.", gender: "female", type: "eastern" },
  { name: "Dania", meaning: "Beautiful girl's name, also the name of closeness and humility.", gender: "female", type: "eastern" },
  { name: "Raghad", meaning: "Beautiful girl's name, also the name of peaceful living.", gender: "female", type: "eastern" },
  { name: "Rana", meaning: "Beautiful girl's name, also the name of looking and attachment.", gender: "female", type: "eastern" },
  { name: "Sara", meaning: "Beautiful girl's name, also the name of Lady Sarah, wife of the Prophet Ibrahim (Abraham).", gender: "female", type: "eastern" },
  { name: "Sidra", meaning: "Beautiful girl's name, also the name of a tree in paradise.", gender: "female", type: "eastern" },
  { name: "Sanaa", meaning: "Beautiful girl's name, also the name of elevation and honor.", gender: "female", type: "eastern" },
  { name: "Shatha", meaning: "Beautiful girl's name, also the name of fragrant perfume.", gender: "female", type: "eastern" },
  { name: "Dhuhha", meaning: "Beautiful girl's name, also the name of midday.", gender: "female", type: "eastern" },
  { name: "Abeer", meaning: "Beautiful girl's name, also the name of a lovely fragrance.", gender: "female", type: "eastern" },
  { name: "Afaaf", meaning: "Beautiful girl's name, also the name of purity and chastity.", gender: "female", type: "eastern" },
  { name: "Ghadeer", meaning: "Beautiful girl's name, also the name of a small stream.", gender: "female", type: "eastern" },
  { name: "Ghufran", meaning: "Beautiful girl's name, also the name of forgiveness and pardon.", gender: "female", type: "eastern" },
  { name: "Hala", meaning: "Beautiful girl's name, also the name of sweetness and beauty.", gender: "female", type: "eastern" },
  { name: "Hadeel", meaning: "Beautiful girl's name, also the name of the cooing sound of a dove.", gender: "female", type: "eastern" },
  { name: "Yasmeen", meaning: "Beautiful girl's name, also the name of a distinctive flower.", gender: "female", type: "eastern" },
  { name: "Jayden", meaning: "The little rooted boy.", gender: "male", type: "western" },
  { name: "Leander", meaning: "The adventurer who explores the land.", gender: "male", type: "western" },
  { name: "Nolan", meaning: "The prince or brave leader.", gender: "male", type: "western" },
  { name: "Carter", meaning: "The seeker or guardian.", gender: "male", type: "western" },
  { name: "Hazel", meaning: "Hazelnut tree.", gender: "male", type: "western" },
  { name: "Jackson", meaning: "Son of Jack.", gender: "male", type: "western" },
  { name: "Levi", meaning: "Raised or elevated.", gender: "male", type: "western" },
  { name: "Maxwell", meaning: "Well of the treasure.", gender: "male", type: "western" },
  { name: "Nathan", meaning: "Gift from God.", gender: "male", type: "western" },
  { name: "Oscar", meaning: "God's knight.", gender: "male", type: "western" },
  { name: "Connor", meaning: "The conqueror or adventurer.", gender: "male", type: "western" },
  { name: "Jason", meaning: "The young one who wears a belt.", gender: "male", type: "western" },
  { name: "Brandon", meaning: "The shining sword or flame.", gender: "male", type: "western" },
  { name: "Craig", meaning: "The rock or small rock.", gender: "male", type: "western" },
  { name: "Derek", meaning: "The popular leader.", gender: "male", type: "western" },
  { name: "Ethan", meaning: "Steadfast or strong.", gender: "male", type: "western" },
  { name: "Philip", meaning: "Friend of horses.", gender: "male", type: "western" },
  { name: "Garrett", meaning: "The brave guardian.", gender: "male", type: "western" },
  { name: "Henry", meaning: "The household ruler.", gender: "male", type: "western" },
  { name: "Everett", meaning: "High or noble.", gender: "male", type: "western" },
  { name: "Justin", meaning: "The just or truthful one.", gender: "male", type: "western" },
  { name: "Kellan", meaning: "Intimate companion.", gender: "male", type: "western" },
  { name: "Leon", meaning: "Brave and strong.", gender: "male", type: "western" },
  { name: "Michael", meaning: "Who is like God, attributed to the angel Michael.", gender: "male", type: "western" },
  { name: "Nicholas", meaning: "The victorious person.", gender: "male", type: "western" },
  { name: "Oliver", meaning: "Possessor of affection and peace.", gender: "male", type: "western" },
  { name: "Peter", meaning: "The rock or large rock.", gender: "male", type: "western" },
  { name: "Quinn", meaning: "The young leader.", gender: "male", type: "western" },
  { name: "Rylan", meaning: "Shining young man of the path.", gender: "male", type: "western" },
  { name: "Samuel", meaning: "The name of God has heard.", gender: "male", type: "western" },
  { name: "Nelly", meaning: "Greek name meaning ray of light.", gender: "female", type: "western" },
  { name: "Eileen", meaning: "Elegant and beautifully dressed.", gender: "female", type: "western" },
  { name: "Julia", meaning: "Foreign name meaning young girl.", gender: "female", type: "western" },
  { name: "Emma", meaning: "A lot of talk.", gender: "female", type: "western" },
  { name: "Olivia", meaning: "Olive tree.", gender: "female", type: "western" },
  { name: "Sophia", meaning: "Wisdom.", gender: "female", type: "western" },
  { name: "Evangeline", meaning: "Beautiful announcement.", gender: "female", type: "western" },
  { name: "Claire", meaning: "Clear and pure.", gender: "female", type: "western" },
  { name: "Madeline", meaning: "Woman from the free city.", gender: "female", type: "western" },
  { name: "Rosalind", meaning: "Garden of roses.", gender: "female", type: "western" },
  { name: "Victoria", meaning: "The winner or successful one.", gender: "female", type: "western" },
  { name: "Catherine", meaning: "Pure and innocent.", gender: "female", type: "western" },
  { name: "Lillian", meaning: "Noble beauty.", gender: "female", type: "western" },
  { name: "Jessica", meaning: "Wealth or vigilance.", gender: "female", type: "western" },
  { name: "Hannah", meaning: "Grace.", gender: "female", type: "western" },
  { name: "Elizabeth", meaning: "God's promise.", gender: "female", type: "western" },
  { name: "Sarah", meaning: "Easy and content.", gender: "female", type: "western" },
  { name: "Rachel", meaning: "Beautiful song.", gender: "female", type: "western" },
  { name: "Natalie", meaning: "Born on Christmas.", gender: "female", type: "western" },
  { name: "Lauren", meaning: "Engaged in sorrow.", gender: "female", type: "western" },
  { name: "Evelyn", meaning: "Life.", gender: "female", type: "western" },
  { name: "Isabel", meaning: "Means God is my oath.", gender: "female", type: "western" },
  { name: "Juliet", meaning: "The young one.", gender: "female", type: "western" },
  { name: "Allison", meaning: "Noble one.", gender: "female", type: "western" },
  { name: "Caroline", meaning: "Beautiful woman.", gender: "female", type: "western" },
  { name: "Megan", meaning: "Shining pearl.", gender: "female", type: "western" },
  { name: "Diana", meaning: "Moon goddess.", gender: "female", type: "western" },
  { name: "Jacqueline", meaning: "Following others.", gender: "female", type: "western" },
  { name: "Bethany", meaning: "Little house.", gender: "female", type: "western" },
  { name: "Kaitlyn", meaning: "Pure girl.", gender: "female", type: "western" },
  { name: "Hillary", meaning: "Bearer of joy.", gender: "female", type: "western" },
  { name: "Melissa", meaning: "Hardworking bee.", gender: "female", type: "western" },
  { name: "Jennifer", meaning: "Genderifer, the feminine one.", gender: "female", type: "western" },
  { name: "Cady", meaning: "A type of tree.", gender: "female", type: "western" },
];
function NameGenerator() {
  const [gender, setGender] = useState("male");
  const [types, setTypes] = useState([]);
  const [generatedName, setGeneratedName] = useState("");
  const [generatedType, setGeneratedType] = useState("");
  const [nameNotFound, setNameNotFound] = useState(false);
  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };
  const handleTypeChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setTypes((prevTypes) => [...prevTypes, value]);
    } else {
      setTypes((prevTypes) => prevTypes.filter((type) => type !== value));
    }
  };
  const generateRandomName = () => {
    setGeneratedName("");
    setGeneratedType("");
    setNameNotFound(false);
    const filteredNames = getFilteredNames();
    if (filteredNames.length > 0) {
      const randomIndex = Math.floor(Math.random() * filteredNames.length);
      const { name, meaning, type } = filteredNames[randomIndex];
      setGeneratedName(`${name} : ${meaning}`);
      setGeneratedType(type);
    } else {
      setNameNotFound(true);
    }
  };
  const getFilteredNames = () => {
    return arabicIslamicNames.filter((name) => {
      return (
        ((gender === "male" && name.gender === "male") ||
          (gender === "female" && name.gender === "female") ||
          (gender === "both" && (name.gender === "male" || name.gender === "female"))) &&
        types.includes(name.type)
      );
    });
  };
  const getName = () => {
    return generatedName && generatedName.includes(":")
      ? generatedName.split(":")[0]
      : "";
  };
  const getMeaning = () => {
    return generatedName && generatedName.includes(":")
      ? generatedName.split(":")[1].trim()
      : "";
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "32px" }}
          >
            <h1 style={{ fontSize: "14px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Welcome to the Muslim Name Generator! Our tool helps you find distinctive Arabic and Islamic names for boys and girls, complete with meanings. Whether you're searching for traditional names or modern options, our generator provides a broad range of names to suit your needs.
                </p>
                <p>
                  Key features of our generator include:
                  <ul>
                    <li>**Arabic and Islamic Names:** Discover names with cultural and religious significance.</li>
                    <li>**Names with Meanings:** Each name comes with a description of its meaning and origin.</li>
                    <li>**Traditional and Modern Options:** Choose from classic Islamic names or contemporary Arabic names.</li>
                    <li>**For Boys and Girls:** Find names suitable for both boys and girls.</li>
                  </ul>
                </p>
                <p>
                  The Muslim Name Generator is designed to make it easy for you to explore various names and understand their significance. This way, you can make an informed choice that reflects your cultural values and personal preferences.
                </p>
                <p>
                  Finding the perfect name for your baby is an important and meaningful step. Use our tool to discover names that resonate with you and provide a special touch to your child's identity.
                </p>
                <p>
                  Start using our Muslim Name Generator today to explore a wide range of Arabic and Islamic names with their meanings and find the ideal name for your new arrival.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle">
                <div
                  className="form-group d-flex align-items-center"
                  style={{ justifyContent: "center" }}
                >
                  <b>
                    <label className="form-label " style={{ fontSize: "19px" }}>
                      Gender
                    </label>
                  </b>
                  <div
                    style={{
                      marginRight: "40px",
                    }}
                  >
                    <FormControlLabel
                      value="male"
                      control={
                        <Radio
                          color="success"
                          checked={gender === "male"}
                          onChange={handleGenderChange}
                        />
                      }
                      label={
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: {
                              md: "17px",
                            },
                          }}
                        >
                          male
                        </Typography>
                      }
                      labelPlacement="start"
                    />
                    <FormControlLabel
                      value="female"
                      control={
                        <Radio
                          color="success"
                          checked={gender === "female"}
                          onChange={handleGenderChange}
                        />
                      }
                      label={
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: {
                              md: "17px",
                            },
                          }}
                        >
                          female
                        </Typography>
                      }
                      labelPlacement="start"
                    />
                    <FormControlLabel
                      value="both"
                      control={
                        <Radio
                          color="success"
                          checked={gender === "both"}
                          onChange={handleGenderChange}
                        />
                      }
                      label={
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: {
                              md: "17px",
                            },
                          }}
                        >
                          Male and Female
                        </Typography>
                      }
                      labelPlacement="start"
                    />
                  </div>
                </div>
                <Box
                  className="d-flex align-items-center"
                  sx={{
                    marginLeft: {
                      lg: "40px",
                      xs: "20px",
                    },
                    justifyContent: "center",
                    marginTop: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={types.includes("islamic")}
                        onChange={handleTypeChange}
                        id="islamic"
                        value="islamic"
                        color="success"
                      />
                    }
                    label={
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: {
                            md: "17px",
                          },
                        }}
                      >
                        Islamc Ariabc
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={types.includes("eastern")}
                        onChange={handleTypeChange}
                        id="eastern"
                        value="eastern"
                        color="success"
                      />
                    }
                    label={
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: {
                            md: "17px",
                          },
                        }}
                      >
                        Arabic Eastern
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={types.includes("western")}
                        onChange={handleTypeChange}
                        id="western"
                        value="western"
                        color="success"
                      />
                    }
                    label={
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: {
                            md: "17px",
                          },
                        }}
                      >
                        Arabic Western
                      </Typography>
                    }
                  />
                  <br />
                </Box>
                <div className="text-center mt-3">
                  <Button
                    variant="contained"
                    color="success"
                    onClick={generateRandomName}
                    sx={{
                      fontSize: {
                        md: "17px",
                      },
                    }}
                  >
                    Generate Name
                  </Button>
                </div>
              </div>
              {generatedName && !nameNotFound && (
                <div style={{ marginTop: "15px", marginBottom: "15px" }}>
                  <table>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Meaning</th>
                        <th>Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "center", fontSize: "18px" }}>
                          {getName()}
                        </td>
                        <td style={{ textAlign: "center", fontSize: "18px" }}>
                          {getMeaning()}
                        </td>
                        <td style={{ textAlign: "center", fontSize: "18px" }}>
                          {generatedType === "islamic"
                            ? "Arabic Islamic"
                            : generatedType === "eastern"
                              ? "Arabic Eastern"
                              : generatedType === "western"
                                ? "Arabic Western"
                                : ""}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList
            CalculatorsTypeId={CalculatorsType.otherCalculators}
          ></MainCalculatorsList>
          <br />
        </div>
         </div>
</div>
  );
}
export default NameGenerator;
